import './TablePagination.css';

function TablePagination({
  page,
  totalPages,
  total,
  from,
  to,
  onPageChange,
  onPrev,
  onNext,
}) {
  if (total <= 0) return null;

  return (
    <div className="table-pagination" role="navigation" aria-label="Table pagination">
      <span className="table-pagination-meta">
        Showing {from}–{to} of {total}
      </span>
      <div className="table-pagination-controls">
        <button
          type="button"
          className="owner-btn owner-btn-secondary owner-btn-sm"
          onClick={onPrev}
          disabled={page <= 1}
        >
          Prev
        </button>
        <label className="table-pagination-page">
          <span className="table-pagination-page-label">Page</span>
          <input
            type="number"
            min={1}
            max={totalPages}
            value={page}
            className="owner-form-input table-pagination-input"
            onChange={(e) => {
              const next = Number(e.target.value) || 1;
              onPageChange(Math.min(totalPages, Math.max(1, next)));
            }}
            aria-label="Page number"
          />
          <span className="table-pagination-page-label">/ {totalPages}</span>
        </label>
        <button
          type="button"
          className="owner-btn owner-btn-secondary owner-btn-sm"
          onClick={onNext}
          disabled={page >= totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
}

export default TablePagination;
